import request from '@/axios';

// 删除导航
export const deleteNavigation = (data) => {
    return request({
        url: `/lebo-desk/tv/navigation/delete`,
        method: 'post',
        data
    })
}

// 获取导航详情
export const detail = (params) => {
    return request({
        url: '/lebo-desk/tv/navigation/detail',
        method: 'get',
        params
    })
}

// 获取导航列表
export const list = (params) => {
    return request({
        url: '/lebo-desk/tv/navigation/list',
        method: 'get',
        params
    })
}

// 新增或修改导航
export const submit = (data) => {
    return request({
        url: '/lebo-desk/tv/navigation/submit',
        method: 'post',
        data
    })
}
